field1 = document.getElementById('field1')
field2 = document.getElementById('field2')
field3 = document.getElementById('field3')
field4 = document.getElementById('field4')

function updateFields () {
    var a = field1.value;
    var b = field2.value;
    var c = field3.value;
    var result = a * b * c;
    if (String(result) != 'Infinity' && String(result) != 'NaN') {
        field4.value = (Math.round(result*1000)/1000)
    }
}